module.exports = __webpack_public_path__ + "img/discount.571f85af.svg";